// extracted by mini-css-extract-plugin
export default {"container":"AppointmentList_container__IbOjf"};